import React from "react"

export const Phone = ({ height = 14, width = 14, fill = "var(--color-primary)", ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16" fill="none">
    <g clip-path="url(#clip0_29317_203722)">
      <path
        d="M14.6679 11.2801V13.2801C14.6687 13.4658 14.6306 13.6496 14.5563 13.8197C14.4819 13.9898 14.3728 14.1425 14.236 14.268C14.0992 14.3935 13.9376 14.4891 13.7618 14.5486C13.5859 14.6081 13.3995 14.6302 13.2146 14.6134C11.1631 14.3905 9.19259 13.6895 7.46126 12.5668C5.85048 11.5432 4.48482 10.1776 3.46126 8.56677C2.33458 6.82758 1.63342 4.84744 1.41459 2.78677C1.39793 2.60242 1.41984 2.41661 1.47892 2.24119C1.53801 2.06576 1.63297 1.90456 1.75777 1.76785C1.88256 1.63114 2.03446 1.52191 2.20378 1.44712C2.37311 1.37233 2.55615 1.33361 2.74126 1.33344H4.74126C5.0648 1.33025 5.37845 1.44482 5.62377 1.65579C5.86908 1.86676 6.02931 2.15974 6.07459 2.48011C6.15901 3.12015 6.31556 3.74859 6.54126 4.35344C6.63095 4.59205 6.65037 4.85138 6.5972 5.10069C6.54402 5.35 6.4205 5.57885 6.24126 5.76011L5.39459 6.60677C6.34363 8.2758 7.72556 9.65774 9.39459 10.6068L10.2413 9.76011C10.4225 9.58086 10.6514 9.45734 10.9007 9.40417C11.15 9.351 11.4093 9.37041 11.6479 9.46011C12.2528 9.68581 12.8812 9.84236 13.5213 9.92677C13.8451 9.97246 14.1409 10.1356 14.3523 10.3851C14.5637 10.6346 14.676 10.9532 14.6679 11.2801Z"
        stroke={fill}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_29317_203722">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
